import { useNavigate } from "react-router-dom";
import { Icon } from "../../components/Icon";

export function EmptyFamilyState() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-1 flex-col items-center justify-center px-7 py-16 text-center lg:mx-auto lg:max-w-xl">
      <div className="mb-7 flex h-24 w-24 items-center justify-center rounded-[30px] bg-[#171714] text-[#FF7A00] shadow-[0_18px_40px_rgba(23,23,20,0.18)]">
        <Icon name="family" size={43} />
      </div>
      <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.18em] text-[#FF7A00]">Начнём вместе</p>
      <h2 className="mb-3 text-[28px] font-extrabold tracking-[-0.05em] text-[#171714] lg:text-[42px]">
        У вас пока нет семьи
      </h2>
      <p className="mb-8 max-w-[300px] text-sm leading-6 text-[#77776F]">
        Создайте семью или примите приглашение, чтобы начать обмениваться пожеланиями
      </p>
      <button
        type="button"
        onClick={() => navigate("/families/new")}
        className="cursor-pointer rounded-full bg-[#FF7A00] px-8 py-3.5 text-sm font-bold text-white shadow-[0_10px_24px_rgba(255,122,0,0.25)] transition-transform hover:-translate-y-0.5"
        aria-label="Создать семью"
      >
        Создать семью
      </button>
    </div>
  );
}
